import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';

class ExpiredPage extends Component {
	constructor(props) {
		super(props);
		this.handleLoginClick = this.handleLoginClick.bind(this);

	}

	handleLoginClick(e) {
		if (window.sco_return_url) {
			window.location.href = window.sco_return_url;
		}
		else {
			this.props.history.push("/")
		}
	}
	componentDidMount() {
		fetch('on_logout',
			{
				method: 'POST',
				credentials: 'same-origin',
				headers:
				{
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(
					{
						'r': new Date().getTime(),
						'secureToken': this.props.secureToken
					}
				)
			})
			.then(function (res) {
				if (!res.ok) {
					throw Error(res.status + " (" + res.statusText + ")");
				}
				return res;
			}).then(res => res.text())
			.then(text => {
			})
			.catch(error => {
			});

	}


	render() {
		let { t } = this.props;
		return (
			<div>
				<AppBar position="static" >
					<Toolbar >
						<Typography variant="title" color="inherit" >
							SAND eCRM
          </Typography>
					</Toolbar>
				</AppBar>
				<div style={{ textAlign: "center" }} >
					<h3> {t('sessionExpired.label')} </h3>
					<Button  color="primary" onClick={this.handleLoginClick} >
						{window.sco_return_url ? t('goBack.button') : t('login.button')}
					</Button>
				</div>
			</div>
		);
	}
}

export default withTranslation()(ExpiredPage);